import { render, staticRenderFns } from "./Edition2025.vue?vue&type=template&id=669cae4d&"
import script from "./Edition2025.vue?vue&type=script&lang=js&"
export * from "./Edition2025.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports